<template>
	<div class="loader-spinner" />
</template>

<style lang="scss">
.loader-spinner {
  width: rem(20px);
  height: rem(20px);

  animation: spin 1s linear infinite;

  border: rem(2px) solid #242424;
  border-top: rem(2px) solid #ffffff;
	border-radius: 50%;

	&.gray {
		border-top: rem(2px) solid #f6f6f6;
	}
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
